<template>
  <div>
    <p class="cm-mg-p-wzd">2. {{ $t('config.ports') }}.</p>
    <hr />
    <div class="row">
      <div class="col-12">
        <fg-input
          class="required-second-step"
          type="number"
          :label="$t('config.number_of_ports')"
          v-model.number="model.ports_number"
          name="config.number_of_ports"
          v-validate="modelValidations.ports_number"
          @change="handleNumberChange"
          :error="getError('config.number_of_ports', true)"
          placeholder="3"
          min="1"
        ></fg-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <span v-for="index in model.ports_number" :key="index">
          <div class="row">
            <div class="col-12">
              <fg-input
                class="required-second-step"
                v-model="model.port_names[index - 1]"
                type="text"
                :label="$t('config.name_of_the_port')"
                :placeholder="$t('config.port_example')"
              ></fg-input>
            </div>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import store from '@/store';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import { MixinExport } from 'src/mixins/mixin-export';

export default {
  data() {
    return {
      headerInfo: {
        Authorization: 'Bearer ' + this.$store.state.auth.token,
      },
      model: {
        ports_id: [],
        ports_number: 0,
        port_names: [],
      },

      modelValidations: {
        ports_number: {
          required: true,
        },
      },
    };
  },
  mixins: [
    MixinPermissions,
    MixinArcgisMap,
    MixinMasters,
    MixinExport,
    MixinForm,
  ],
  methods: {
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    handleNumberChange($event) {},

    validate() {
      let elThis = this;
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, this.model);
          this.$emit('fillMarketForm', 'secondStep', this.model);
          return res;
        })
        .then((resp) => {
          return store
            .dispatch('utils/validationInputsRequired', '-second-step')
            .then(function (response) {
              if (response) {
                return true;
              }
            });
        });
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading();
    } else this.showHideLoading();
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.ports_number = editForm.ports.length;
      editForm.ports.forEach((element) => {
        this.model.ports_id.push(element.id);
        this.model.port_names.push(element.name);
      });
    }
  },

  destroyed() {
    localStorage.removeItem('listFiles');
  },
};
</script>
<style></style>
